import common from '@/store/common/mutations';
import * as types from './mutation-types';


import { SEARCH_PARAMS, CAMPAIGN_INFO, PAGING_INFO } from './state';

export default {
	...common,
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.campaignList = []; //고품회수목록
	},
	[types.CAMPAIGN_INFO_INIT]: state => {
		state.campaignInfo = CAMPAIGN_INFO(); 
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.CAMPAIGN_INFO]: (state, { key, value }) => {
		state.campaignInfo[key] = value;
	}
	
};
